// extracted by mini-css-extract-plugin
export default {"title":"z6yRn","text":"zg9uA"};